(() => {
  // Only run on desktop-like pointers
  const canHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  if (!canHover) return;

  const cursor = document.createElement("div");
  cursor.className = "sl-cursor";
  document.body.appendChild(cursor);

  let mouseX = window.innerWidth / 2;
  let mouseY = window.innerHeight / 2;
  let currentX = mouseX;
  let currentY = mouseY;

  const speed = 0.18; // lower = slower/smoother

  const setVisible = () => {
    cursor.style.opacity = "1";
  };

  const setHidden = () => {
    cursor.style.opacity = "0";
  };

  window.addEventListener("mousemove", (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
    setVisible();
  });

  window.addEventListener("mouseout", () => setHidden());
  window.addEventListener("blur", () => setHidden());

  // Pointer state on interactive elements
  const interactiveSelector = [
    "a",
    "button",
    "[role='button']",
    "input",
    "select",
    "textarea",
    "summary",
    ".button",
    ".btn",
    ".product-card a",
    ".card a"
  ].join(",");

  document.addEventListener("mouseover", (e) => {
    const el = e.target.closest(interactiveSelector);
    cursor.classList.toggle("is-pointer", !!el);
  });

  document.addEventListener("mousedown", () => cursor.classList.add("is-down"));
  document.addEventListener("mouseup", () => cursor.classList.remove("is-down"));

  // Smooth follow animation
  const animate = () => {
    currentX += (mouseX - currentX) * speed;
    currentY += (mouseY - currentY) * speed;

    cursor.style.transform = `translate(${currentX}px, ${currentY}px) translate(-50%, -50%)`;
    requestAnimationFrame(animate);
  };

  requestAnimationFrame(animate);
  
})();
